import { ArrowLeft, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { memo } from "react";

type NavigationMobileTriggerProps = {
  onBack: () => void;
  onClose: () => void;
} & React.ComponentProps<"div">;

const NavigationMobileTrigger = ({
  onBack,
  onClose,
  className,
  children,
  ...rest
}: NavigationMobileTriggerProps) => {
  return (
    <div
      className={cn(
        "py-[14.5px] px-6 border-b border-b-neutral-100 flex items-center justify-between",
        className
      )}
      {...rest}
    >
      <button
        type="button"
        className="inline-flex items-center text-lg leading-[150%] font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded"
        onClick={onBack}
        aria-label={`Back to ${children}`}
        title={`Back to ${children}`}
      >
        <ArrowLeft width={24} height={24} className="shrink-0 mr-2" />
        <span>{children}</span>
      </button>
      <button
        type="button"
        className="inline-flex w-6 h-6 bg-transparent p-0 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded"
        onClick={onClose}
        aria-label="Close navigation"
        title="Close navigation"
      >
        <X width={24} height={24} className="w-6 h-6 text-gray-800" />
      </button>
    </div>
  );
};

export default memo(NavigationMobileTrigger);
